// extracted by mini-css-extract-plugin
module.exports = {"moreButtonMobile":"n004c","small":"_3Lo0S"};